import { Paths, STORAGE_KEY } from "@constants";
import { generatePath } from "react-router-dom";

/** Canonical member referral URL: `{origin}/r/{refCode}` */
export function buildMemberReferralAbsoluteUrl(refCode: string | undefined | null): string {
  const siteUrl = `${window.location.protocol}//${window.location.host}`;
  const code = refCode?.trim() || "????";
  return siteUrl + generatePath(Paths.PUBLIC.REFERRAL_CALLBACK, { refCode: code });
}

export const storeReferralCode = (refCode: string | undefined | null) => {
  if (refCode) {
    sessionStorage.setItem(STORAGE_KEY.REF_CODE, refCode);
  }
};

export const getReferralCode = () => {
  return sessionStorage.getItem(STORAGE_KEY.REF_CODE) || undefined;
};

export const clearReferralCode = () => {
  sessionStorage.removeItem(STORAGE_KEY.REF_CODE);
};
